const styles = (theme) => ({
  root: {},
  title: {
    marginTop: 2,
    marginBottom: 6,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightMedium,
  },
});

export default styles;
